import * as R from "ramda";
import { appUserDS } from "./app_user";
import { appUserProshopDS } from "./app_user_proshop";
import { ballDrilledDS } from "./ball_drilled";
import { customerProshopDS } from "./customer_proshop";
import { customerDS } from "./customer";
import { proshopDS } from "./proshop";
import { specSheetDS } from "./spec_sheet";
import { thumbCutDS } from "./thumb_cut";
import { dashboardDS } from "./dashboard";
import { jobServiceDS } from "./job_service";
import { salesPersonDS } from "./sales_person";
import { jobLocationDS } from "./job_location";
import { jobDS } from "./job";
import { jobDetailDS } from "./job_detail";
import { jobBoardDashboardDS } from "./job_board_dashboard";
import * as Promise from "bluebird";
Promise.config({ warnings: false, longStackTraces: false, asyncHooks: false });

const datasourcesPromises = {
  appUserDS,
  appUserProshopDS,
  ballDrilledDS,
  customerProshopDS,
  customerDS,
  proshopDS,
  specSheetDS,
  thumbCutDS,
  dashboardDS,
  jobServiceDS,
  salesPersonDS,
  jobLocationDS,
  jobDS,
  jobDetailDS,
  jobBoardDashboardDS,
  // thumbInfoDS,
};

export let datasources = {};

export const initDatasources = (currentUserId, actions) =>
  new Promise((success) => {
    const dsPromises = R.pipe(
      R.map((dsPromise) => dsPromise(currentUserId, actions)()),
      R.values
    )(datasourcesPromises);

    Promise.all(dsPromises)
      .then((dsPromisesResult) => {
        // console.log("datasources initialized");
        datasources = R.zipObj(R.keys(datasourcesPromises), dsPromisesResult);
        success();
      })
      .catch(
        (error) => console.error("initDatasources ERROR!!!", error) || success()
      );
  });
